// import { supportsGoWithoutReloadUsingHash } from 'history/DOMUtils';
import { api } from '../../../config';

interface IGetRoutesTenants {
  readAll: () => string;
  read: (tenantId: string) => string;
}
interface IGetRoutes {
  clients: IGetRoutesTenants;
}

const getRoutes = (host: string): IGetRoutes => ({
  clients: {
    readAll: (): string => `${host}/clients`,
    read: (tenantId: string): string => `${host}/clients/${tenantId}`,
  },
});

const routes = getRoutes(api.iamApi.host);

export default routes;
